export const DesktopG99Logo =
  'https://growth99.com/storage/2024/09/logo-icon.svg';
export const G99ColoredLogo = 'https://growth99.com/storage/2024/09/LOGO.svg';

export const MfaThumbnail =
  'https://static.vecteezy.com/system/resources/thumbnails/041/290/222/small/user-protection-modern-icon-illustration-free-png.png';
